import Color from 'color';

import baseModalStyles from './BaseModal';

export default theme => ({
    ...baseModalStyles,
    iconContainer: {
        paddingTop: 25,
        paddingBottom: 20,
    },
    icon: {
        color: theme.accentColor,
        fontSize: 92,
    },
    modalTitle: {
        fontSize: 26,
        fontWeight: 500,
        paddingBottom: 20,
        margin: 0,
    },
    modalText: {
        fontSize: 18,
        paddingBottom: 20,
    },
    buttonContainer: {
        paddingBottom: 40,
    },
    button: {
        padding: '8px 70px',
        backgroundColor: theme.accentColor,
        'user-select': 'none',
        fontWeight: 'lighter',
        color: 'white',
        fontSize: 14,
        borderRadius: 1,
        border: '1px solid transparent',
        cursor: 'pointer',
        '&:focus': {
            outline: 'none',
        },
        '&:active': {
            backgroundColor: Color(theme.accentColor)
                .darken(0.2)
                .hslString(),
        },
    },
});
